/* eslint no-extend-native: 0 */
// core-js comes with Next.js. So, you can import it like below
import 'core-js/es6'
import 'core-js/modules/es7.array.includes'
import 'core-js/modules/es7.object.values'

import 'url-search-params-polyfill'
import 'intersection-observer'
